import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useContent } from "@/contexts/ContentContext";
import { CMS } from "@/constants/testIds/cms";

export function ResourcesEditModal({ open, onOpenChange }) {
  const { content, setPath } = useContent();
  if (!content) return null;
  const resources = content.resources || [];

  function updateField(i, field, value) {
    setPath(`resources.${i}.${field}`, value);
  }

  function addLink() {
    setPath("resources", [...resources, { label: "New resource", url: "" }]);
  }

  function removeLink(i) {
    setPath("resources", resources.filter((_, idx) => idx !== i));
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="cms-dialog">
        <DialogHeader>
          <DialogTitle>Edit resources</DialogTitle>
          <DialogDescription>
            Manage the links shown in the Resources dropdown. Click "Save changes" in the admin bar to publish.
          </DialogDescription>
        </DialogHeader>
        <div className="resource-edit-list" data-testid={CMS.resourceList}>
          {resources.map((r, i) => (
            <div className="resource-edit-row" key={i}>
              <Input
                value={r.label}
                onChange={(e) => updateField(i, "label", e.target.value)}
                placeholder="Label"
                data-testid={`${CMS.resourceLabelInput}-${i}`}
              />
              <Input
                value={r.url}
                onChange={(e) => updateField(i, "url", e.target.value)}
                placeholder="https://"
                data-testid={`${CMS.resourceUrlInput}-${i}`}
              />
              <button type="button" onClick={() => removeLink(i)} data-testid={`${CMS.resourceRemoveButton}-${i}`}>
                Remove
              </button>
            </div>
          ))}
        </div>
        <Button type="button" variant="outline" onClick={addLink} data-testid={CMS.resourceAddButton}>
          Add link
        </Button>
      </DialogContent>
    </Dialog>
  );
}
